"use client";

import { useAuth } from "@/contexts/AuthContext";
import { useCurrentUserPoolEntry } from "./usePool";

/**
 * Whether the current user has an active pool entry in the specified
 * tournament. Used to conditionally show the "Player Pool" navbar tab.
 *
 * Backed by `useCurrentUserPoolEntry` (live `onSnapshot`) so the navbar
 * shares cache with the pool page and stays consistent when the user joins,
 * leaves, or gets matched into a team.
 */
export function useUserPoolEntryForTournament(tournamentId: string) {
  const { user } = useAuth();
  return useCurrentUserPoolEntry(tournamentId, user?.id);
}
